import styled from 'styled-components';
import { Flex } from '../Flex';
import { mobileCss } from '../../..';

export const FormLayoutSlideOut = styled.div<{ open?: boolean }>`
  opacity: ${({ open }) => (!open ? '0' : '1')};
  transition: all 300ms ease;
  height: ${({ open }) => (!open ? '0' : '100%')}
`;

export const FormLayout = styled(Flex) <{ cols?: number, isGapBottom?: boolean, isGapTop?: boolean, padding?: string }>`${({
  cols = 2, theme, isGapBottom, isGapTop, padding,
}) => `
  ${isGapTop ? `margin-top: ${theme.padding[7]};` : ''}
  ${isGapBottom ? `margin-bottom: ${theme.padding[7]};` : ''}
  width: 100%;  
  display: grid;
  align-items: flex-start;
  grid-auto-rows: min-content;
  grid-template-columns: repeat(${cols}, minmax(0, 100%));
  grid-gap: ${theme.padding[7]} calc(${theme.padding[11]} + ${theme.padding[5]});
  padding: ${padding || 0};
  ${mobileCss(`
    grid-template-columns: auto;
  `)};
`}`;
